import { render, staticRenderFns } from "./repairDescription.vue?vue&type=template&id=4c295afa&scoped=true"
import script from "./repairDescription.vue?vue&type=script&lang=js"
export * from "./repairDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c295afa",
  null
  
)

export default component.exports